import { styled } from '@linaria/react'
import React, { FC } from 'react'
import { FormattedMessage } from 'react-intl'
import SvgLogo from '../svgr/Logo'
import { Typography } from '../ui/Typography'
import { colors } from '../styles/colors'
import { useTonConnect } from '../hooks/useTonConnect'
import { isTestnet } from '../shared/utils/network'

export const LogoBlock: FC = () => {
  const { network } = useTonConnect()

  return (
    <LogoContainer>
      <LogoWrapper>
        <SvgLogo width={38} height={30} />
        {isTestnet(network) && <TestBadge fontSize={9}>TESTNET</TestBadge>}
      </LogoWrapper>

      <Box>
        <LogoText fontSize={20} fontWeight={900} color={colors.secondary}>
          VoteBox
        </LogoText>

        <SubtitleText fontSize={9} fontWeight={400}>
          <FormattedMessage
            id="logo-subtitle"
            defaultMessage="Голосуй и зарабатывай"
          />
        </SubtitleText>
      </Box>
    </LogoContainer>
  )
}

const LogoContainer = styled.div`
  display: grid;
  grid-template-columns: auto 1fr;
  gap: 8px;
  grid-gap: 8px;
  align-items: end;
  min-width: 0;

  @media (max-width: 360px) {
    gap: 6px;
    grid-gap: 6px;
  }
`

const LogoWrapper = styled.div`
  position: relative;
  display: inline-block;
`

const TestBadge = styled(Typography)`
  position: absolute;
  top: 4px;
  left: -5px;
  right: -5px;
  text-align: center;
  background: ${colors.dangerActive};
  color: ${colors.white};
  padding: 2px 4px;
  border-radius: 4px;
  box-shadow: 0 1px 3px ${colors.shadowMedium};
`

const Box = styled.div`
  display: flex;
  flex-direction: column;
  min-width: 0;
  overflow: hidden;
`

const LogoText = styled(Typography)`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`

const SubtitleText = styled(Typography)`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

  @media (max-width: 360px) {
    font-size: 8px;
  }
`
